import React, { Component } from 'react';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import ModalComponent from '../Layout/Modal';
import { message } from '../../_constants';
import CustomLinkedIN from '../Linkdin/CustomLinkedIN.js';
import { Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { notification } from 'antd';
import { uploadResumeFile, reqUestDeniedByCity, getAllCityByCountryAction, getAllCountryAction } from '../../actions/FindRecCompany';
import { sendResumeAction } from '../../actions/SendResume';
import { getAllHome } from '../../actions/home';
import { userJobListAction, jobViewAction } from '../../actions/job';
import $ from 'jquery';
import { listCityCountryStateAction } from '../../actions/Admin/CountryCityAction'
import { getRecruiterView } from '../../actions/home'

let className = [];
let fieldsArr = [];
let carts = {};

class JobCompanyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsList: [],
            code: '',
            fieldSelct: '',
            disabledButton: false,
            detailsModal: false,
            resumeSectionModel: false,
            listStatus: true,
            resUmeUpload: false,
            resumeNotSelect: false,
            sendResumeOption: true,
            requestServer: true,
            fileName: "",
            categoryId: "",
            emailId: "",
            reqObj: { search: "" },
            formData: {},
            detailsData: {},
            resumeSendFor: "",
            tags: [],
            list: [],
            suggestions: [],
            fieldOption: [],
            tagvalue: [],
            checkedValue: [],
            optionSelect: [],
            jobcount: 0,
            jobList: [],
            jobRequest: true,
            selectResumeType: "upload",
            sendResumeForType: "job",
            viewDataDetails:{},
            viewRecruter:true,
            userData: JSON.parse(localStorage.getItem('userData')),
        };
    }

    componentWillMount() {
        const {match} = this.props;
        const {jobId,recruterId,city} = match.params;
        
        if(jobId && recruterId){
            this.props.jobViewAction({ userUrlLink :recruterId , jobId :Number(jobId) ,})
        }
        const userData = JSON.parse(localStorage.getItem('userData'));
        if ((userData && userData.userType === "company") || (userData && userData.userType === "recruiter")) {
            this.props.history.push({
                pathname: "/dashboard-home",
                state: { reqObj: "" }
            });
        }

        if (localStorage.getItem('userLogin') === "true") {
            const userData = JSON.parse(localStorage.getItem('userData'))
            if (userData && userData.userType === "user") {
                this.setState({
                    sendResumeOption: false
                })
            }
        }

        let cuntryReqObj = {
            countryName: this.state.countrySelect,
        }
        let reqObj = {
            "limit": 10,
            "offset": 0,
            "specializations": [],
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        this.props.getAllHome(reqObj);
    }

    suggeStionPost = (limit, page, tvalue) => {
        const { location, match } = this.props;
        const {recruterId,city} = match.params;
        const { reqObj, tagvalue, viewDataDetails } = this.state;

        if (tvalue && tvalue.length > 0) {
            tagvalue.push(tvalue);
        }

        let reqObjs = {
            "limit": limit,
            "offset": page,
            "order": "createdAt",
            "direction": "asc",
            "categoryId": reqObj && reqObj.fieldSelct,
        }
        if (viewDataDetails) {
            reqObjs.companyId = viewDataDetails._id;
        }

        this.setState({
            listStatus: true,
            jobRequest: true,
            requestServer: true
        })
        this.props.userJobListAction(reqObjs);
    }

    componentWillReceiveProps(nextProps) {
     
        if( nextProps && nextProps.recruiterView && nextProps.recruiterView.statusCode == 200 && this.state.viewRecruter){
            this.setState({
                viewRecruter:false,
                viewDataDetails:nextProps.recruiterView.data
            },function(){
                this.suggeStionPost(10, 0)
              }
            )
        }
        if (nextProps.jobType === "jobView" && nextProps.jobResponse && nextProps.jobResponse.statusCode === 200 && this.state.jobRequest) {
            this.setState({
                viewDataDetails:nextProps.jobResponse.data.userDetail,
                detailsData: nextProps.jobResponse.data,
                jobRequest: false
            },function(){
                window.scrollTo(0, 600);
            })
        }

        if (nextProps.jobType === "jobView" && nextProps.jobResponse && nextProps.jobResponse.data && nextProps.jobResponse.data.statusCode === 500 && this.state.jobRequest) {
            this.setState({
                jobRequest: false
            },(function(){
                notification.error({
                    message: nextProps.jobResponse.data.msg,
                    className:'errorNotification',
                    duration: 3
                });
            }))
        }

        let userDetail = JSON.parse(localStorage.getItem('userData'));
        if (localStorage.getItem('userLogin') === "true" && userDetail.userType !== "admin") {
            this.setState({
                sendResumeOption: false,
                userData: userDetail
            })
        }

        const { listStatus, resUmeUpload, resumeSectionModel } = this.state;

        if (nextProps.resumeSent && nextProps.resumeSent.statusCode === 200 && resumeSectionModel) {
            notification.success({
                message: "Resume Send Successfully",
                className:'successNotification',
                duration: 3
            });
            this.setState({
                fileName: "",
                resumeSectionModel: !resumeSectionModel,
                resumeNotSelect: false,
                requestServer: false,
            })
        }

        if (nextProps.resume && nextProps.resume.statusCode && nextProps.resume.statusCode === 200 && this.state.resUmeUpload) {

            var reqResume = {
                providerType: this.state.sendResumeForType,
                id: this.state.checkedValue,
                userEmail: this.state.userData.email,
                resumeImage: nextProps.resume.file_name
            }
            this.props.sendResumeAction(reqResume);
            this.setState({
                resUmeUpload: false
            })
        }

        // if (nextProps.listPost && Array.isArray(nextProps.listPost.data) && listStatus) {
        //     var list = this.state.list
        //     list = [];
        //     list = nextProps.listPost.data;
        //     this.setState({
        //         requestServer: false,
        //         listStatus: false,
        //         list: list,
        //         totalCount: nextProps.listPost.count

        //     })
        // }

        // if (nextProps.listPost && nextProps.listPost.statusCode === 500 && nextProps.listPost.status === "Error") {
        //     var listData = this.state.list
        //     listData = [];
        //     listData = nextProps.listPost.data;
        //     this.setState({
        //         requestServer: false,
        //         listStatus: false,
        //         list: listData,
        //         totalCount: nextProps.listPost.count
        //     })
        // }

        if (nextProps && nextProps.fields && nextProps.fields.length > 0) {
            var fieldsList = nextProps.fields ;
            var option = [] ;
            for (var i in nextProps.fields) {
                let obj = {
                    value: fieldsList[i]._id,
                    label: fieldsList[i].name
                }
                option.push(obj);
            }
            this.setState({
                fieldsList: nextProps.fields,
                fieldOption: option,
            })

            if (this.state.reqObj && this.state.reqObj.fieldSelct) {
                var fieldSelct = this.state.reqObj.fieldSelct;
                let fieldOption = this.state.fieldOption
                let optionSelect = this.state.optionSelect
                for (var n in fieldSelct) {
                    var index = fieldOption.findIndex(p => p.value == [fieldSelct[n]])
                    if (index > -1) {
                        optionSelect.push(fieldOption[index])
                    }
                }
                this.setState({
                    optionSelect: optionSelect
                });
            }
        }
    }

    handleDelete = (i) => {
        const { tags, tagvalue } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
            tagvalue: tagvalue.filter((tagvalue, index) => index !== i),
        });
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        this.setState({ tags: newTags });
    }

    handleAddition = (tag) => {
        var tagvalue = tag.text;
        this.setState(state => ({ tags: [...state.tags, tag] }));
        this.setState(state => ({ tagvalue: [...state.tagvalue, tagvalue] }));
        this.suggeStionPost(10, 0, tagvalue);
    }

    sendResume = (id) => {
        var checkValue = this.state.checkedValue;
        checkValue.push(id);
        if (checkValue.length > 0) {
            this.setState({
                sendResumeForType: "job",
                checkedValue: checkValue,
                resumeSectionModel: !this.state.resumeSectionModel
            })
        } else {
            notification.error({
                message: "Please Select CheckBox",
                className:'errorNotification',
                duration: 3
            });
        }
    }

    sendResumeToConnect = (id, type, e) => {

        var checkValue = this.state.checkedValue;
        checkValue.push(id);
        if (checkValue.length > 0) {
            this.setState({
                checkedValue: checkValue,
                sendResumeForType: type,
                resumeSectionModel: !this.state.resumeSectionModel
            })
        } else {
            notification.error({
                message: "Please Select CheckBox",
                className:'errorNotification',
                duration: 3
            });
        }
    }

    resumeUpload = (e) => {
        this.setState({
            fileName: "",
            resumeSendFor: "",
            resumeSectionModel: !this.state.resumeSectionModel
        })
    }

    sendResumeTo = (e) => {
        if (this.state.selectResumeType === "profile") {
            if (this.state.resumeSendFor !== "") {
                var reqResume = {
                    id: this.state.checkedValue,
                    userEmail: this.state.userData.email,
                    providerType: "job",
                    resumeImage: this.state.resumeSendFor
                }
                this.props.sendResumeAction(reqResume);
            } else {
                this.setState({
                    resumeNotSelect: true
                })
            }
        } else {
            e.preventDefault();
            this.setState({
                resUmeUpload: true
            }, function() {
                var file = document.getElementById("file").files[0];
                this.props.uploadResumeFile(file)
            })
        }
    }

    emailInput = e => {
        e.preventDefault();
        this.setState({
            emailId: e.target.value
        })
    }

    fileSelect = (e) => {
        e.preventDefault();
        var file = document.getElementById("file").files[0];
        this.setState({
            fileName: file.name
        })
    }

    handleChangeAddress = () => {}

    onChangeForSlctResume = (e) => {
        this.setState({
            resumeSendFor: e.target.value,
            resumeNotSelect: false
        })
    }

    handleChangeTypeResume = (e) => {
        let selectResumeType = this.state.selectResumeType
        selectResumeType = e.target.value
        if (selectResumeType === "profile") {
            if (this.state.userData && this.state.userData.resume && this.state.userData.resume !== "") {
                this.setState({
                    selectResumeType: selectResumeType,
                });
            } else {
                notification.error({
                    message: "Please Uplode resume in Profile",
                    className:'errorNotification',
                    duration: 3
                });
            }
        } else {
            this.setState({
                selectResumeType: selectResumeType,
            });
        }
    }

    
    signIn = () => {
        this.props.history.push({
            pathname: "/sign-in",
            state: { "redirectPath": "/profile" }
        });
    }

    viewAllJobs = () => {
        const {match} = this.props;
        const {jobId,recruterId,city} = match.params;
        
        this.props.history.push({
            pathname: "/profile/"+recruterId,
            state: { "redirectPath": "","scroll":true }
        });
    }

    render() {

        const {viewDataDetails, resumeNotSelect, requestServer, resumeSendFor, fieldOption, fileName, detailsData, sendResumeOption, selectResumeType } = this.state;
        let resumeArr = this.state.userData && this.state.userData.resume ? this.state.userData.resume : [];

        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        let education = [];
        let keySkill = [];
        let jobLocation = [];
        if (detailsData) {
            if(detailsData.education){
                for (let x in detailsData.education){
                    education.push(<span>{detailsData.education[x]} <br/></span>)
                }
            }
            if(detailsData.keySkill){
                for (let x in detailsData.keySkill){
                    keySkill.push(<span>{detailsData.keySkill[x]} <br/></span>)
                }
            }
            if(detailsData.jobLocation){
                for (let x in detailsData.jobLocation){
                    jobLocation.push(<span>{detailsData.jobLocation[x].city} <br/></span>)
                }
            }
        }

        var workingCity = [];
        var categeoryName = [];
        var speciality = [];

        if (Array.isArray(viewDataDetails.companyAddress)) {
            for (var z in viewDataDetails.companyAddress) {
                workingCity.push(<div className="tub">{viewDataDetails.companyAddress[z].city}</div>)
            }
        }

        if (Array.isArray(viewDataDetails.specializations)) {
            for (var y in viewDataDetails.specializations) {
                speciality.push(<div className="tub">{viewDataDetails.specializations[y]}</div>)
            }
        }

        if (Array.isArray(viewDataDetails.categoryId)) {
            for (var x in viewDataDetails.categoryId) {
                var index = fieldOption.findIndex(p => p.value === viewDataDetails.categoryId[x])
                if (index !== -1) {
                    categeoryName.push(<div className="tub">{fieldOption[index].label}</div>);
                }
            }
        }

        return (
            <div className="outer-wrapper">
                <Header props={ this.props } />
                    <div className="container">
                        <div className="row">
                            <div className="top-row">
                                <div className="col-md-12">
                                    <div className="img-job">
                                        <img src={viewDataDetails.image?this.props.auth.showImage(viewDataDetails.image):process.env.REACT_APP_USER_ICON_IMAGE} alt="new" className="rounded" scale={4} vertical={0} horizontal={5} />
                                    </div>
                                    <div className="job-name">{viewDataDetails.firstName}</div>
                                    <h5 className="job-type">{viewDataDetails.userType}</h5>
                                </div>
                                <div className="col-md-10 offset-md-1">
                                    <div className="detail-right">
                                        <div className="block-1">
                                            <div className="short-label">ShortBio</div>
                                            <div className="short-name">{viewDataDetails.shortBio}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-10 offset-md-1">
                                    <div className="short-city">City</div>
                                    <div className="short-name">{workingCity}</div>
                                </div>
                                <div className="col-md-10 offset-md-1">
                                    <div className="short-city">Category</div>
                                    <div className="cat-name">{categeoryName}</div>
                                </div>
                                <div className="col-md-10 offset-md-1">
                                    <div className="short-city">Speciality</div>
                                    <div className="short-name">{speciality}</div>
                                </div>
                                <div className="col-md-3 offset-md-9">
                                    <Button className="btn mrgn resume-btn1" onClick={this.sendResumeToConnect.bind(this,viewDataDetails._id,"jobProvider")}>Connect With {viewDataDetails.firstName}</Button>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="job-title">
                                    <div className="profile-title">
                                        <h3 className="job-head">Job </h3>
                                       <button onClick={this.viewAllJobs} className="allJobView btn"> View All Job</button>
                                    </div>
                                   { detailsData && detailsData._id && 
                                    <div className="job-wrapper">
                                        <div className="row job-row">
                                            <div className="col-md-12">
                                                <label  className="pf-label"><strong>Job Title</strong> </label>
                                                <div className="lab-text">{detailsData.title}</div>
                                            </div>
                                            <div className="col-md-12">
                                               <label className="lab-head"><strong>Job Summary</strong></label>
                                                <div className="lab-text">{detailsData.summary}</div>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="lab-head"><strong>Job Description</strong></label>
                                                <div className="lab-text">{detailsData.description}</div>
                                            </div>
                                            <div className="col-md-4">
                                               <label className="lab-head"><strong>Employment Type</strong></label>
                                                <div className="lab-text">{detailsData.employementType}</div>
                                            </div>
                                            <div className="col-md-2">
                                                <label className="lab-head"><strong>Experience</strong></label>
                                                <div className="lab-text">{detailsData.experienceRequired}</div>
                                            </div>
                                            <div className="col-md-2">
                                                <label className="lab-head"><strong>Opening</strong></label>
                                                 <div className="lab-text">{detailsData.opening}</div>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="lab-head"><strong>Salary</strong></label>
                                                 <div className="lab-text">{detailsData.salary}</div>
                                            </div>
                                            <div className="col-md-12"><label className="lab-head"><strong>Key Skill</strong></label>
                                                <div className="lab-text">{keySkill}</div>
                                            </div>
                                            <div className="col-md-12"><label className="lab-head"><strong>Education</strong></label>
                                                <div className="lab-text">{education}</div>
                                            </div>
                                            <div className="col-md-12"><label className="lab-head"><strong>Location</strong></label>
                                                <div className="lab-text">{jobLocation}</div>
                                            </div>
                                        </div><br/>

                                        <div className="col-md-8">
                                            <Button className="btn mrgn resume-btn" onClick={this.sendResumeToConnect.bind(this,detailsData._id,"job")}>Send Resume</Button>
                                        </div>
                                            
                                        <Modal backdrop="static" keyboard={false} isOpen={this.state.resumeSectionModel} toggle={this.resumeUpload} className={this.props.className}>
                                            <ModalHeader toggle={this.resumeUpload}>Send Resume</ModalHeader>
                                            <ModalBody className="spc-radi">
                                                {sendResumeOption&&
                                                    <span>
                                                        <div className="modal-wrap">
                                                            <div className="warn-text">{message.sendResumeWithoutSignin}</div>
                                                            <div className="signinPopup">
                                                                <CustomLinkedIN textTtile={"Sign in with LinkedIn"} props={ this.props }/>
                                                                <button className="btn btn-signIn drop-Signin" title="Sign In" onClick={this.signIn}><i className="fa fa-sign-in"></i> Sign-In</button>&nbsp;
                                                            </div>
                                                        </div>

                                                    </span>
                                                }

                                                {!sendResumeOption&&
                                                    <div className="row mnge-spce">
                                                        <div className="col-md-12 ">
                                                            <label>Select saved resume</label>
                                                            <input type="radio" name="selectResume" id="profile" className="" value="profile" checked={selectResumeType==="profile"} onChange={this.handleChangeTypeResume} />
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label>Upload new resume</label>
                                                            <input type="radio" name="selectResume" id="upload" className="" value="upload" checked={selectResumeType==="upload"} onChange={this.handleChangeTypeResume} />
                                                        </div>
                                                    </div>
                                                }
                                                {!sendResumeOption&&
                                                    <div>
                                                        {selectResumeType === "upload" &&
                                                            <form  onSubmit={this.sendResumeTo}  validate>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="box">
                                                                            <h5 className="upload-label">Upload Resume</h5>
                                                                            <div className="upload-icon"><i className="fa fa-upload"></i></div>
                                                                            <input type="file" className="box__file" name="files" id="file" onChange={this.fileSelect.bind(this)} accept=".xlsx,.xls,.doc,.docx,.ppt, .pptx,.txt,.pdf" required/>
                                                                            <div className="uploaded-file-name">{fileName}</div>
                                                                            <label htmlFor="file"><strong>Choose a file</strong><span className="box__dragndrop"> or drag it here</span>.</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="modal-btn-block">
                                                                    <Button type="submit" className="btn modal-save-btn" disabled={sendResumeOption}>Submit</Button>
                                                                    <a type="cancel" className="btn modal-cancel-btn" onClick={this.resumeUpload}>Cancel</a>
                                                                </div>
                                                            </form>
                                                        }

                                                       {/* <input type="radio" className="radio-multiple" name="resumeSendFor" id="key" value="96a2253d-f1ca-499e-8076-54c2859adf92.docx" checked={resumeSendFor === "96a2253d-f1ca-499e-8076-54c2859adf92.docx"}  />*/}
                                                        <div className="remob-p"> 
                                                            {selectResumeType==="profile" &&
                                                                resumeArr.map((resume,index)=>(
                                                                    <div className="spc-manage-com">
                                                                        <input type="radio" className="radio-multiple" name="resumeSendFor" id={resume._id} value={resume.resumeImage} checked={resumeSendFor === resume.resumeImage?true:false}   onChange={((e)=>this.onChangeForSlctResume(e))} />
                                                                        <span className="pf-label border-sqr spcf-comp">
                                                                        <a  href={process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+resume.resumeImage} >{resume.name}</a> 
                                                                        {/* <a  onClick={this.fileDownLoads(process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+resume.resumeImage,resume.name)}  >{resume.name}</a> */}
                                                                        </span> 
                                                                    </div>
                                                                ))

                                                            }

                                                        {resumeNotSelect&&

                                                            <span>Please Select Resume</span>
                                                        }
                                                        </div>

                                                        {selectResumeType === "profile" &&
                                                            <div className="col-md-12 btnfinfcomp">
                                                                <Button type="submit" className="btn modal-save-btn" onClick={this.sendResumeTo} disabled={sendResumeOption}>Submit</Button>
                                                                <a type="cancel" className="btn modal-cancel-btn" onClick={this.resumeUpload}>Cancel</a>
                                                            </div>
                                                        }
                                                    </div>
                                                }    
                                            </ModalBody> 
                                        </Modal>       

                                    </div>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        jobType: state.Job.type,
        jobResponse: state.Job.response,
        fields: state.home.response.data,
        listPost: state.FindRecCompany.response && state.FindRecCompany.response.data ? state.FindRecCompany.response.data : [],
        resume: state.FindRecCompany.resume,
        city: state.FindRecCompany.city,
        resumeSent: state.SendResume.response,
        recruiterView:state.home.responseRecruiter
    };
}

export default withRouter(connect(mapStateToProps, {
    userJobListAction,
    getAllHome,
    getRecruiterView,
    uploadResumeFile,
    sendResumeAction,
    reqUestDeniedByCity,
    listCityCountryStateAction,
    jobViewAction
   // getAllCountryAction,
   // getAllCityByCountryAction
})(JobCompanyDetails));


// WEBPACK FOOTER //
// ./src/components/Search/JobCompanyDetails.js